import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Loader2, QrCode, RefreshCw, X } from "lucide-react";
import api from "@/lib/api";
import { btnGhost, errMsg, inp, lbl } from "./ui";

export default function UsherQrModal({ event, ushers, initialId, onClose }) {
  const active = ushers.filter((u) => u.status !== "revoked");
  const [aid, setAid] = useState(initialId || active[0]?.id || "");
  const [qr, setQr] = useState(null);
  const [err, setErr] = useState(null);
  const [left, setLeft] = useState(0);

  const generate = async (id = aid) => {
    if (!id) return;
    setQr(null); setErr(null);
    try { setQr((await api.post(`/attendance/events/${event.id}/ushers/${id}/qr`, { origin_url: window.location.origin })).data); }
    catch (e) { setErr(errMsg(e, "Could not create QR code")); }
  };
  useEffect(() => { generate(aid); }, [aid]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!qr) return;
    const tick = () => setLeft(Math.max(0, Math.round((new Date(qr.expires_at) - Date.now()) / 1000)));
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [qr]);

  return (
    <div className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm flex items-start sm:items-center justify-center overflow-y-auto p-4" data-testid="att-qr-modal">
      <div className="w-full max-w-sm bg-[#111] border border-white/10 rounded-2xl p-6 my-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-serif-display text-2xl text-white flex items-center gap-2"><QrCode size={20} className="text-[#D4AF37]" /> Usher QR code</h3>
          <button onClick={onClose} aria-label="Close" data-testid="att-qr-close" className="text-neutral-400 hover:text-white"><X size={20} /></button>
        </div>
        {!active.length ? <p className="text-sm text-neutral-400">Invite an usher by email first — the QR code is a backup for an existing invitation.</p> : (
          <>
            <label className={lbl}>Usher</label>
            <select className={inp} data-testid="att-qr-usher" value={aid} onChange={(e) => setAid(e.target.value)}>
              {active.map((u) => <option key={u.id} value={u.id}>{u.name ? `${u.name} (${u.email})` : u.email}</option>)}
            </select>
            <div className="mt-5 flex flex-col items-center">
              {err && <p className="text-sm text-red-300" data-testid="att-qr-error">{err}</p>}
              {!qr && !err && <Loader2 className="animate-spin text-[#D4AF37] my-16" />}
              {qr && (
                <>
                  <div className={`bg-white p-4 rounded-xl ${left ? "" : "opacity-20"}`} data-testid="att-qr-code"><QRCodeSVG value={qr.url} size={232} level="M" /></div>
                  <div className="text-sm text-white mt-4 text-center" data-testid="att-qr-identity">{qr.usher.name || qr.usher.email}</div>
                  <div className="text-xs text-[#D4AF37] text-center mt-1">{qr.zones.join(" · ")}</div>
                  <div className="text-xs text-neutral-500 mt-3 text-center" data-testid="att-qr-expiry">
                    {left ? `Single use · expires in ${Math.floor(left / 60)}:${String(left % 60).padStart(2, "0")}` : "Expired"}
                  </div>
                  <button onClick={() => generate()} data-testid="att-qr-refresh" className={`${btnGhost} mt-4`}><RefreshCw size={13} /> New code</button>
                </>
              )}
            </div>
            <p className="text-[11px] text-neutral-500 mt-5 leading-relaxed">Ask the usher to scan with their phone camera. It opens a counter for their assigned zones only. Their email invitation keeps working.</p>
          </>
        )}
      </div>
    </div>
  );
}
